// Шрифты и иконки бренда v2.0 — одно место на весь сайт (02.11.2026).
// React-страницы получают их из корневого head (src/routes/__root.tsx),
// статические HTML — из withSiteChrome (src/components/site/site-chrome-html.tsx).
// Постранично шрифты не подключаются: раньше у каждой страницы был свой набор,
// и /start не грузил их вовсе, а заголовки без прямого Source Serif уходили в Georgia.

/** Nunito Sans 400–800 (ось opsz — как была) + Source Serif 4 прямой и курсив 400/500. */
export const BRAND_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=Nunito+Sans:opsz,wght@6..12,400;6..12,600;6..12,700;6..12,800&family=Source+Serif+4:ital,wght@0,400;0,500;1,400;1,500&display=swap";

export const THEME_COLOR = "#1E5A6B";

export const BRAND_FONT_LINKS = [
  { rel: "preconnect", href: "https://fonts.googleapis.com" },
  { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" as const },
  { rel: "stylesheet", href: BRAND_FONTS_URL },
];

// Старый PNG — первым, как запасной для браузеров без SVG-иконок.
export const BRAND_ICON_LINKS = [
  { rel: "icon", href: "/assets/logo/yolutap-favicon.png", type: "image/png" },
  { rel: "icon", href: "/yolutap-icon.svg", type: "image/svg+xml" },
  { rel: "icon", href: "/favicon-32.png", type: "image/png", sizes: "32x32" },
  { rel: "icon", href: "/favicon-16.png", type: "image/png", sizes: "16x16" },
  { rel: "apple-touch-icon", href: "/apple-touch-icon.png", sizes: "180x180" },
  { rel: "manifest", href: "/manifest.webmanifest" },
];

/**
 * Отчёты (/result, /print, /report/…/preview, /abroad-report/…) берут Nunito Sans
 * и Source Serif со своего домена (reportSharedCss.ts): PDF печатается в Browser
 * Rendering, и Google-шрифты там не успевали. Второй источник тех же семейств им не нужен.
 */
export function pathHasOwnFonts(pathname: string): boolean {
  return (
    /^\/session\/[^/]+\/(result|print)\/?$/.test(pathname) ||
    pathname.startsWith("/report/") ||
    pathname.startsWith("/abroad-report/")
  );
}

/** То же для статических страниц: строка для <head>. */
export function brandHeadHtml(extraFontsUrl?: string): string {
  const fonts = [
    `<link rel="preconnect" href="https://fonts.googleapis.com" />`,
    `<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />`,
    `<link rel="stylesheet" href="${BRAND_FONTS_URL}" />`,
    extraFontsUrl ? `<link rel="stylesheet" href="${extraFontsUrl}" />` : "",
  ];
  const icons = BRAND_ICON_LINKS.map(
    (l) =>
      `<link rel="${l.rel}" href="${l.href}"${"type" in l ? ` type="${l.type}"` : ""}${"sizes" in l ? ` sizes="${l.sizes}"` : ""} />`,
  );
  return [...fonts, ...icons, `<meta name="theme-color" content="${THEME_COLOR}" />`].join("");
}
